
import { useState, useEffect } from 'react';

export type Theme = 'light' | 'dark';

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    // Vérifier d'abord localStorage
    const savedTheme = localStorage.getItem('feel-theme') as Theme;
    if (savedTheme) {
      return savedTheme;
    }
    // Sinon utiliser la préférence système
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    
    // Supprimer l'ancien thème
    root.classList.remove('light', 'dark');
    
    // Ajouter le nouveau thème
    root.classList.add(theme);
    root.setAttribute('data-theme', theme);
    
    // Sauvegarder dans localStorage
    localStorage.setItem('feel-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return { theme, toggleTheme };
};
